<template>
  <div class="qf-loading" v-show="state">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>
<script>
export default {
  name: "qf-loading",
  props: {
    state: {
      type: Boolean,
      required: true
    }
  }
};
</script>
<style scoped>
.qf-loading {
  width: 80px;
  height: 40px;
  margin: 0 auto;
  margin-top: 100px;
}

.qf-loading span {
  display: inline-block;
  width: 8px;
  height: 100%;
  border-radius: 4px;
  background: lightgreen;
  -webkit-animation: load 1s ease infinite;
}

@-webkit-keyframes load {
  0%,
  100% {
    height: 40px;
    background: lightgreen;
  }

  50% {
    height: 70px;
    margin: -15px 0;
    background: lightblue;
  }
}

.qf-loading span:nth-child(2) {
  -webkit-animation-delay: 0.2s;
}

.qf-loading span:nth-child(3) {
  -webkit-animation-delay: 0.4s;
}

.qf-loading span:nth-child(4) {
  -webkit-animation-delay: 0.6s;
}

.qf-loading span:nth-child(5) {
  -webkit-animation-delay: 0.8s;
}
</style>